var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgExternalHealthResources = function SvgExternalHealthResources(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    fillRule: "evenodd",
    d: "M28.332 11.75c.69 0 1.25.56 1.25 1.25v7.083h7.085a1.25 1.25 0 0 1 0 2.5h-7.085v7.084a1.25 1.25 0 0 1-2.5 0v-7.084H20a1.25 1.25 0 0 1 0-2.5h7.082V13c0-.69.56-1.25 1.25-1.25Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M8.75 21C8.75 10.368 17.369 1.75 28 1.75c10.632 0 19.25 8.618 19.25 19.25 0 7.975-3.721 15.398-7.736 21.104-4.03 5.726-8.453 9.865-10.07 11.299a2.16 2.16 0 0 1-2.889 0c-1.616-1.434-6.04-5.573-10.069-11.299C12.471 36.398 8.75 28.975 8.75 21ZM28 4.25c-9.25 0-16.75 7.5-16.75 16.75 0 7.228 3.393 14.14 7.281 19.666 3.708 5.27 7.776 9.153 9.469 10.675 1.693-1.522 5.761-5.406 9.469-10.675C41.357 35.14 44.75 28.228 44.75 21c0-9.25-7.5-16.75-16.75-16.75Z",
    clipRule: "evenodd"
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M8.75 21C8.75 10.368 17.369 1.75 28 1.75c10.632 0 19.25 8.618 19.25 19.25 0 7.975-3.721 15.398-7.736 21.104-4.03 5.726-8.453 9.865-10.07 11.299a2.16 2.16 0 0 1-2.889 0c-1.616-1.434-6.04-5.573-10.069-11.299C12.471 36.398 8.75 28.975 8.75 21ZM28 4.25c-9.25 0-16.75 7.5-16.75 16.75 0 7.228 3.393 14.14 7.281 19.666 3.708 5.27 7.776 9.153 9.469 10.675 1.693-1.522 5.761-5.406 9.469-10.675C41.357 35.14 44.75 28.228 44.75 21c0-9.25-7.5-16.75-16.75-16.75Z",
    clipRule: "evenodd"
  })));
};
export default SvgExternalHealthResources;